import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState
} from 'react';
import { useHistory } from 'react-router';
import useTranslations from '../../../hooks/useTranslations';
import isPrivilegeEqualsTo from '../../../utils/isPrivilegeEqualsTo';
import { FormContext } from '../FormContext';
import ThankYouView from '../view/ThankYouView';
import queryString from 'query-string';
import { FormBuilderContext } from '../../engine/FormBuilderEngine';

const ThankYouEngine = ({
  contentMsg: givenContentMsg,
  displayLinks = true
}) => {
  const t = useTranslations();
  const history = useHistory();
  const [submissionId, setSubmissionId] = useState(false);
  const [referenceId, setReferenceId] = useState(null);
  const {
    form = {},
    getSubmissionsId = () => new Promise(r => r(null)),
    getReferenceId = () => new Promise(r => r(null)),
    formId = ''
  } = useContext(FormContext);
  const { form: formWithFormKey = {} } = useContext(FormBuilderContext);

  const getFormMessage = useCallback(() => {
    //if we receive the prop contentMsg with info
    if (givenContentMsg) {
      return overridePlaceholders(givenContentMsg);
    }
    //if we don't receive the prop contentMsg but we have a customized message saved in the form
    if (
      form.postSubmitMsgs &&
      form.postSubmitMsgs.default &&
      form.postSubmitMsgs.default.text
    ) {
      return overridePlaceholders(form.postSubmitMsgs.default.text);
    }
    //set to default if none of the above is true
    return 'forms.thanks.submitted';
  }, [form, referenceId, givenContentMsg]);

  const overridePlaceholders = message => {
    if (message.includes('${referenceId}')) {
      if (referenceId) {
        return message.replaceAll('${referenceId}', referenceId);
      } else {
        return message.replaceAll(
          '${referenceId}',
          formWithFormKey.formKey + '-123'
        );
      }
    }
    return message;
  };

  useEffect(() => {
    getSubmissionsId(false).then(sid => {
      getReferenceId().then(rid => {
        setSubmissionId(sid);
        setReferenceId(rid);
      });
    });
  }, [getSubmissionsId, getReferenceId]);

  const viewSubmission = async () => {
    const _submissionId = submissionId
      ? submissionId
      : await getSubmissionsId(false);
    if (
      history.location.pathname === `/forms/assigned/${formId}/${_submissionId}`
    ) {
      window.location.reload();
    } else {
      history.push(`/forms/assigned/${formId}/${_submissionId}`);
    }
  };

  const go2Dashboard = () => {
    if (isPrivilegeEqualsTo('form:write')) {
      history.push('/forms');
    } else {
      history.push('/welcome');
    }
  };
  const contentMsg = useMemo(getFormMessage, [getFormMessage]);
  const isPublicForm = form.sharingType === 'anonymous';
  const showDashboardLink = !isPublicForm;

  const justSigned = queryString.parse(window.location.search).thankyou || '';
  const viewProps = {
    contentMsg: typeof contentMsg === 'string' ? t(contentMsg) : contentMsg,
    go2Dashboard,
    viewSubmission,
    submissionId,
    displayLinks,
    isLinkEnabled: !isPublicForm && !justSigned && displayLinks,
    isDashboardBtnEnabled: showDashboardLink && displayLinks
  };

  return <ThankYouView {...viewProps} />;
};

export default ThankYouEngine;
